import { gql } from '@apollo/client';

import SERVICE_TYPES_FRAGMENT from '../fragments/services';

// eslint-disable-next-line import/prefer-default-export
export const CREATE_SERVICE_TYPE = gql`
  ${SERVICE_TYPES_FRAGMENT}
  mutation createServiceTypeEntity($doc: ServiceTypeInput!) {
    createServiceTypeEntity(doc: $doc) {
      ...ServiceTypesFragment
    }
  }
`;

export const UPDATE_SERVICE_TYPE = gql`
  ${SERVICE_TYPES_FRAGMENT}
  mutation updateServiceTypeEntity($updatedDoc: ServiceTypeInput!, $filter: ServiceTypeInput!) {
    updateServiceTypeEntity(updatedDoc: $updatedDoc, filter: $filter) {
      ...ServiceTypesFragment
    }
  }
`;

export const DELETE_SERVICE_TYPE = gql`
  mutation deleteServiceTypeEntity($id: String!) {
    deleteServiceTypeEntity(id: $id) {
      message
    }
  }
`;
